import LOCAL_STORAGE_KEYS from "constants/STORAGE_KEYS";
import useTryCatch from "hooks/useTryCatch";
import { getVisitorDetails } from "lib/register-link";
import { useEffect, useState } from "react";
import { Route, Routes as Switch } from "react-router-dom";
import ROUTES from "routes";
import useLocalStorage from "utils/useLocalStorage";
import {
  RegisterLoginPage,
  RegistrationDonePage,
  SignUpPage,
  VerifyRegistrationPage,
} from ".";

const RegistrationLinkPage = () => {
  const [visitor, setVisitor] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    countryCode: "",
    password: "",
  });
  const [isLoading, setLoading] = useState(true);
  const [token] = useLocalStorage(LOCAL_STORAGE_KEYS.token);
  const prefillVisitorData = useTryCatch(async () => {
    const api = await getVisitorDetails();
    if (api.ok) {
      const { first_name, last_name, email, country_code, contact_number } =
        api.data;
      setVisitor((prev) => ({
        firstName: first_name,
        lastName: last_name,
        email,
        password: "",
        countryCode: country_code,
        phoneNumber: contact_number,
      }));
    }
  }, setLoading);
  useEffect(() => {
    const isUpdating = !!token;
    const isInVerifyPage = ROUTES.registerLink.verifyLink;
    if (isUpdating && !isInVerifyPage) {
      prefillVisitorData();
    } else {
      setLoading(false);
    }
  }, []);
  return (
    <Switch>
      <Route path="" element={<RegisterLoginPage />} />
      <Route
        path="/signup"
        element={
          <SignUpPage
            isFetchingVisitor={isLoading}
            visitor={visitor}
            setVisitor={setVisitor}
          />
        }
      />
      <Route
        path="/verify"
        element={
          <VerifyRegistrationPage
            isFetchingVisitor={isLoading}
            visitor={visitor}
            setVisitor={setVisitor}
          />
        }
      />
      <Route
        path="/done"
        element={
          <RegistrationDonePage
            isFetchingVisitor={isLoading}
            visitor={visitor}
            setVisitor={setVisitor}
          />
        }
      />
    </Switch>
  );
};

export default RegistrationLinkPage;
